import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { Typography } from "@mui/material";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { FilteredElbResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const lbColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Load Balancer", "load_balancer_name"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("lb"),

  resourceAccountColumnDef,

  resourceTotalSpendColumnDef,

  getResourceCreationTimeColumnDef("Creation time"),

  {
    field: "resource.has_attachments",
    headerName: "Targets Empty",
    headerTooltip:
      "Targets Empty: YES - indicates that the load balancer has no targets in a running state.",
    cellRenderer: ({ data }: ICellRendererParams<FilteredElbResourceItem>) => {
      return (
        <Typography variant="body2">
          {data?.resource?.has_attachments ? "Yes" : "No"}
        </Typography>
      );
    },
  },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
